import { IconAction } from "@common/controls/Icon/component";
import { Common } from "@common/types";
import classNames from "classnames";
import React from "react";

export type ModalHeaderButtonProps = {
  className?: string;
  icon: Common.IconType;
  onClick?: (e: React.MouseEvent) => void;
  style?: React.CSSProperties;
};
export const ModalHeaderButton = ({ className, ...props }: ModalHeaderButtonProps) => (
  <IconAction {...props} className={classNames("modal-header-btn", className)} size={28} />
);

type ModalCloseButtonProps = {
  onClick?: () => void;
};
export const ModalCloseButton = (props: ModalCloseButtonProps) => (
  <ModalHeaderButton onClick={props.onClick} className="close" icon={Common.IconType.Cross} />
);
